/** The log level. Used for filtering and tagging logging events */
export var LogLevel;
(function (LogLevel) {
    /** Debug. Should only be used for logging to help development. Debug is the lowest level. */
    LogLevel["Debug"] = "DEBG";
    /** Error. Used to log out errors and exceptions */
    LogLevel["Error"] = "EROR";
    /** Informational. Used to provide runtime information */
    LogLevel["Info"] = "INFO";
    /** Trace. Used to log program flow */
    LogLevel["Trace"] = "TRCE";
    /** Warning. Used to log errors and exceptions that do not break the program but need to be klnown about */
    LogLevel["Warn"] = "WARN";
})(LogLevel || (LogLevel = {}));
